module.exports = __webpack_public_path__ + "img/logotype.9e18a7db.svg";